/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';

dayjs.extend(customParseFormat);
dayjs.extend(utc);

export function convertTimestampToISOString(dateString: string): string {
  if (!dateString) return dateString;

  try {
    const parts = dateString.split('-');
    if (parts.length < 3) return dateString;

    //Convert month from MAR to Mar as dayjs only supports months in this format
    parts[1] = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();

    const formattedDateString = parts.join('-');
    const format = 'DD-MMM-YY hh:mm:ss:SSSSSSSSS A';
    const parsedDate = dayjs.utc(formattedDateString, format);

    return parsedDate.isValid() ? parsedDate.format('YYYY-MM-DDTHH:mm:ss.SSSZ') : dateString;
  } catch (error) {
    return dateString;
  }
}
